import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionAdr {
    // Impression ADR depuis planning général
    public static imprimerADR(datePlanning, periode, common: CommonService, isNotImprimer?) {
        /*const param = {
            'servlet': 'DBImprimeADR',
            'module': 'Ecobennes',
            'type': 'tableau',
            'compression': 'false',
            'pathImpression': 'Ecobennes/tmp/EtiquetteADR/',
            'data': [
                'DBImprimeADR',
                datePlanning,
                '' + common.user[2],
                periode,
                '0'
            ]
        };*/

        const param = {
            'servlet': 'DBImprimeADR',
            'module': 'Ecobennes',
            'type': 'map',
            'compression': 'false',
            'data': {
                'CLEF_SITE': '' + common.user[2],
                'PERIODE': '' + periode,

                'CLEF_FORMAT': {
                    'typeParam': 'int',
                    'valeur': 0
                },
                'LISTE_DATE': datePlanning
            }
        };

        if (!isNotImprimer) {
            param['pathImpression'] = 'Ecobennes/tmp/EtiquetteADR/';
            param['data']['IS_MERGE'] = {
                'typeParam': 'boolean',
                'valeur': true
            };
        }

        return common.post('', { param: param });
    }

    public static getUrlADR(data) {
        const path = data.URL;
        const listURLADR = [];
        data.LISTE.forEach(e => {
            listURLADR.push(path + '' + e.PDF);
        });

        return listURLADR;
    }

    // Impression ADR depuis planning du chauffeur
    public static imprimerChauffeurADR(datePlanning, periode, clefCamion, clefFormat, common: CommonService, isNotImprimer?) {
        const param = {
            'servlet': 'DBImprimeADR',
            'module': 'Ecobennes',
            'type': 'map',
            'compression': 'false',
            // 'pathImpression': 'Ecobennes/tmp/EtiquetteADR/',
            'data': {
                'CLEF_SITE': '' + common.user[2],
                'PERIODE': '' + periode,
                // 'IS_MERGE': {
                //     'typeParam': 'boolean',
                //     'valeur': true
                // },
                'CLEF_FORMAT': {
                    'typeParam': 'int',
                    'valeur': clefFormat
                },
                'CLEF_CAMION': {
                    'typeParam': 'int',
                    'valeur': clefCamion
                },
                'LISTE_DATE': datePlanning
            }
        };

        if (!isNotImprimer) {
            param['pathImpression'] = 'Ecobennes/tmp/EtiquetteADR/';
            param['data']['IS_MERGE'] = {
                'typeParam': 'boolean',
                'valeur': true
            };
        }

        return common.post('', { param: param });
    }

    // Impression ADR depuis planning du chauffeur
    public static mergeFilePDF(LIST_FICHIERS, common: CommonService, isNotImprimer?) {
        const param = {
            'servlet': 'DBGestionAngular',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'pathImpression': 'Recylog/tmp/',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 22
                },
                'NOM_FICHIER_MERGE': common.user[0] + '_adrs_' + common.getTimestamp() + '.pdf',
                'LIST_FICHIERS': LIST_FICHIERS
            }
        };

        return common.post('', { param: param });
    }
}
